import { BREAKPOINTS, CONFIG } from '../config';
import getEventHandlerResize from '../ResizeHandler';
import initModules from '../initModules';

class BfvCoachStations {
  constructor(options = {}) {
    this.$root = options.element;
    this.$table = this.$root.querySelector('table');
    this.$tableXs = null;
    this.$tableM = this.$table.cloneNode(true);
    this.$trs = this.$table.querySelectorAll('tr');
    this.$ths = this.$table.querySelectorAll('th');
    this.$thsXs1 = [...this.$ths].slice(0, 3);
    this.$thsXs2 = [...this.$ths].slice(3);
    this.currentBreakpointKey = getEventHandlerResize().getCurrentViewport();
  }

  init() {
    this.initTable();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener(CONFIG.events.VIEWPORT_CHANGED, (event) => {
      this.currentBreakpointKey = event.detail.viewport;

      this.initTable();
    });
  }

  /**
   * Renderes the table according to its viewport
   */
  initTable() {
    if (this.currentBreakpointKey === BREAKPOINTS.xsmall) {
      if (!this.$tableXs) {
        this.buildTableXs();
      }

      this.$table.innerHTML = this.$tableXs.innerHTML;
    } else {
      this.$table.innerHTML = this.$tableM.innerHTML;
    }

    initModules({ rootElement: this.$table }); // load team icons
  }

  /**
   * Creates the table for viewport XS
   * For every data row in the original table create 4 rows (1st and 3rd created from header row)
   */
  buildTableXs() {
    this.$tableXs = document.createElement('table');

    const $headRow = [...this.$trs][0];

    [...this.$trs].slice(1).forEach(($tr, rowIndex) => { // only data rows but not head row

      const $trXs = [0, 1, 2, 3].map(() => document.createElement('tr'));

      if (rowIndex === 0) { // tr element itself exists even if empty for correct table styling
        $trXs[0] = $headRow.cloneNode();
        $trXs[0].innerHTML = '';
        this.$thsXs1.forEach(($cell, cellIndex) => {
          const $cloneCell = $cell.cloneNode(true);

          if (cellIndex > 0) {
            $cloneCell.colSpan = 3;
          } else if (cellIndex === 0) {
            $cloneCell.colSpan = 2;
          }

          $trXs[0].appendChild($cloneCell);
        });
      } else {
        $trXs[0].style.height = '30px';
      }

      $trXs[1] = $tr.cloneNode();
      $trXs[1].innerHTML = '';
      [...$tr.querySelectorAll('td')].slice(0, 3).forEach(($cell, cellIndex) => {
        const $cloneCell = $cell.cloneNode(true);

        if (cellIndex > 0) {
          $cloneCell.colSpan = 3;
        } else if (cellIndex === 0) {
          $cloneCell.colSpan = 2;
        }

        $trXs[1].appendChild($cloneCell);
      });

      $trXs[2] = $headRow.cloneNode();
      $trXs[2].innerHTML = '';
      this.$thsXs2.forEach(($cell) => {
        $trXs[2].appendChild($cell.cloneNode(true));
      });

      $trXs[3] = $tr.cloneNode();
      $trXs[3].innerHTML = '';
      [...$tr.querySelectorAll('td')].slice(3).forEach(($cell) => {
        $trXs[3].appendChild($cell.cloneNode(true));
      });

      $trXs.forEach(($row) => this.$tableXs.appendChild($row));
    });
  }
}

export default BfvCoachStations;
